import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_PREFIX;
const header = {
    'Content-Type': 'application/json',
    'Accept': '*/*'
};

const getDataPyme = (params, query = null) => {
    let url = `${baseUrl}/busquedaPymes${query!==null ? query : ''}`;
    return axios
        .get(url, {
            headers: header,
            params: params
        })
};

const getDataCategories = () => {
    let url = `${baseUrl}/categorias`;
    return axios
        .get(url, {
            header,
        })
};

const getDataLocation = () => {
    let url = `${baseUrl}/regionesycomunas`;
    return axios
        .get(url, {
            headers: header,
        })
};

const isRedirected = () => {
    let url = `${baseUrl}/compraPymeBusquedaActiva`;
    return axios
        .get(url, {
            headers: header,
        })
};

export default {
    getDataPyme, getDataCategories, getDataLocation, isRedirected
};
